export default {
  monthlyTitle: {
    en: 'Want more fragrances?',
  },
  biMonthlyTitle: {
    en: 'Have too many products?',
  },
  triMonthlyTitle: {
    en: 'Have too many products?',
  },
  bimonthlySubscribePageTitle: {
    en: 'RESUBSCRIBE: EVERY 2 MONTHS',
  },
  bimonthlySubscribePageSubTitle: {
    en: 'Billed every 2 months. Renews automatically, cancel any time.',
  },
  bimonthlySubscribePageOrderInfoText: {
    en: 'FREQUENCY: EVERY OTHER MONTH',
  },
  trimonthlySubscribePageTitle: {
    en: 'RESUBSCRIBE: EVERY 3 MONTHS',
  },
  trimonthlySubscribePageSubTitle: {
    en: 'Billed every 3 months. Renews automatically, cancel any time.',
  },
  trimonthlySubscribePageOrderInfoText: {
    en: 'FREQUENCY: EVERY 3 MONTHS',
  },
  text: {
    en: 'Adjust your subscription frequency {periodLine}!',
  },
  monthlyPeriodLine: {
    en: 'back to every 1 month',
  },
  biMonthlyPeriodLine: {
    en: 'to every 2 months',
  },
  triMonthlyPeriodLine: {
    en: 'to every 2 or 3 months',
  },
  monthly: {
    en: 'every month',
  },
  biMonthly: {
    en: 'every other month',
  },
  triMonthly: {
    en: 'every 3 months ',
  },
  pleaseText: {
    en: 'Ship my Scentbird {period}, please!',
  },
  shipItEvery: {
    en: 'Ship it every {planName}',
  },
  nextShippingDate: {
    en: 'Your next Scentbird will ship between {date}',
  },
  nextBillingDate: {
    en: 'Your card will next be billed on {date}',
  },
  changePlanErrorMessage: {
    en: 'Sorry, we have a server error, please try again later.',
  },
}
